import React, { useEffect, useState } from 'react'
import { getStudentDeviceInfo } from '../../../service/student/student.service';
import Loaders from '../../../components/loaders/Loaders';
import moment from 'moment';
import { FaDotCircle, FaRegDotCircle } from 'react-icons/fa';

export default function StudentDeviceLog() {

    const [loading, setLoading] = useState(false);
    const [fetchData, setFetchData] = useState<any>([]);

    const fetch = async()=>{
        setLoading(true);
        const get: any = await getStudentDeviceInfo("__","student");
        if(get?.status ==='success'){
            setFetchData(get.message);
            setLoading(false);
        }else{
            setLoading(false);
        }
    }

    useEffect(()=>{
        fetch();
    }, [])

  return (
    loading ? 
      <Loaders type='spinner' />
      :
    <>
<div className='relative overflow-x-auto'>
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                      <thead className='text-xs uppercase bg-gray-700   text-gray-400'>
                        <tr>
                          <th scope="col" className="px-6 py-3">
                            ID
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Device
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Browser
                          </th>
                          <th scope="col" className="px-6 py-3">
                            OS
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Date
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {

                         fetchData?.length > 0 ?
                         fetchData.map((item:any, index:number) => (
                            <tr key={index} className='bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200'>
                              <td className="px-6 py-4 whitespace-nowrap flex gap-5">
                                {index+1}
                                {
                                    index === 0 ? <FaRegDotCircle className='text-xl text-green-700' /> : <FaRegDotCircle className='text-xl text-red-700' />
                                }
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                {item.device}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                {item.browser}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                {item.os}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                {
                                  moment(item.createAt).format('YYYY-MM-DD HH:mm')
                                }
                              </td>
                            </tr>
                          ))
                          :
                          <tr>
                            <td colSpan={5} className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white" >No Record found</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
    </>
  )
}
